<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import SectionTitle from '$components/section-title.svelte';
  import { button } from '$components/ui/button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { zoomOnScrollHandler } from '$lib/transitions';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { TextWithImageStoryblok } from '$types/bloks';
  import { reducedMotion } from '@significa/svelte-toaster';
  import { onMount } from 'svelte';

  export let block: TextWithImageStoryblok;

  onMount(() => {
    if (block.slight_zoom_on_scroll && !$reducedMotion) {
      const handler = () => {
        zoomOnScrollHandler(imageContainer, (n) => (scale = n));
      };
      window.addEventListener('scroll', handler);
      return () => window.removeEventListener('scroll', handler);
    }
  });

  let imageContainer: HTMLElement;
  let scale = 1;
</script>

<section class="px-2 pt-16 pb-2 lg:pt-[72px] lg:pb-8 lg:px-8" style:--scale={scale}>
  <div class="container isolate mx-auto" use:storyblokEditable={block}>
    {#if block.title?.[0]}
      <SectionTitle block={block.title[0]} />
    {/if}
    <div bind:this={imageContainer} class="overflow-hidden rounded-md">
      {#if !!block.cta?.[0] && !!block.image?.filename}
        {@const { href, target, rel } = $getAnchorFromCmsLink(block.cta[0].link)}
        <a {href} {target} {rel} class="relative h-[560px] w-full flex grow items-end p-4">
          <CmsImage
            image={block.image}
            options={{ size: [1440, 0] }}
            class="absolute inset-0 scale-[var(--scale)] -z-10 h-full w-full rounded-md object-cover"
          />
          <div
            class={cn(
              button({ variant: 'secondary', size: 'md' }),
              'w-full backdrop-blur lg:w-fit'
            )}
          >
            {block.cta[0]?.label}
          </div>
        </a>
      {:else if !!block.image?.filename}
        <CmsImage
          image={block.image}
          options={{ size: [1440, 0] }}
          class="relative z-10 h-[560px] scale-[var(--scale)] rounded-md object-cover"
        />
      {/if}
    </div>
  </div>
</section>
